import "core-js/modules/es.array.concat.js";
/*
* ColaPay web框架组
*
* */
import Vue from 'vue';
import './element_lazy'; // 按需加载element
import uploader from 'vue-simple-uploader';
import APlayer from '@moefe/vue-aplayer';
// time line css
import '../../node_modules/timeline-vuejs/dist/timeline-vuejs.css';
// 路由守卫
import Bus from '@/utils/bus';
// 加载网站配置文件夹
import config from './config';
Vue.prototype.$GIN_VUE_ADMIN = config;
Vue.use(Bus);
Vue.use(APlayer, {
  defaultCover: 'https://github.com/u3u.png',
  productionTip: true
});
Vue.use(uploader);
console.log("\n   \u6B22\u8FCE\u4F7F\u7528 ColaPay\n   \u5F53\u524D\u7248\u672C:V2.4.4\n   \u52A0\u7FA4\u65B9\u5F0F:\u5FAE\u4FE1\uFF1Ashouzi_1994 QQ\u7FA4\uFF1A622360840\n   \u9ED8\u8BA4\u81EA\u52A8\u5316\u6587\u6863\u5730\u5740:http://127.0.0.1:".concat(process.env.VUE_APP_SERVER_PORT, "/swagger/index.html\n   \u9ED8\u8BA4\u524D\u7AEF\u6587\u4EF6\u8FD0\u884C\u5730\u5740:http://127.0.0.1:").concat(process.env.VUE_APP_CLI_PORT, "\n   \u5982\u679C\u9879\u76EE\u8BA9\u60A8\u83B7\u5F97\u4E86\u6536\u76CA\uFF0C\u5E0C\u671B\u60A8\u80FD\u8BF7\u56E2\u961F\u559D\u676F\u53EF\u4E50:https://www.ColaPay.com/docs/coffee\n"));